if (!customElements.get('izone-team-landing')) {
  customElements.define('izone-team-landing', class extends HTMLElement {
    connectedCallback() {
      this.updateLinks();
      this.copyButton = this.querySelector('[data-copy-code]');
      if (!this.copyButton || !navigator.clipboard?.writeText) return;
      this.copyButton.hidden = false;
      this.onCopy = async () => {
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(this.dataset.coupon);
          status.textContent = this.dataset.copiedMessage;
          this.copyButton.textContent = this.dataset.copiedMessage;
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            this.copyButton.textContent = this.originalCopyLabel;
            status.textContent = '';
          }, 2500);
        } catch {
          status.textContent = this.dataset.copyError;
        }
      };
      this.originalCopyLabel = this.copyButton.textContent;
      this.copyButton.addEventListener('click', this.onCopy);
    }

    disconnectedCallback() {
      this.copyButton?.removeEventListener('click', this.onCopy);
      clearTimeout(this.copyTimer);
    }

    updateLinks() {
      const destination = new URL(this.dataset.shopPath, location.origin);
      if (destination.origin !== location.origin) return;
      const ignored = new Set(['redirect', 'discount', 'section_id', 'sections', 'view']);
      const incoming = new URLSearchParams(location.search);
      for (const [key, value] of incoming) {
        if (!ignored.has(key) && !destination.searchParams.has(key)) {
          destination.searchParams.append(key, value);
        }
      }
      if (this.dataset.affiliateUrl) {
        try {
          const affiliate = new URL(this.dataset.affiliateUrl, location.origin);
          for (const [key, value] of affiliate.searchParams) {
            if (!ignored.has(key)) destination.searchParams.set(key, value);
          }
        } catch {
          return;
        }
      }
      const discount = new URL(this.dataset.discountPath, location.origin);
      discount.pathname += encodeURIComponent(this.dataset.coupon);
      discount.searchParams.set('redirect', destination.pathname + destination.search);
      const href = this.dataset.coupon ? discount.pathname + discount.search : destination.pathname + destination.search;
      this.querySelectorAll('[data-team-shop]').forEach(link => { link.href = href; });
    }
  });
}
